var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconDental40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9952 8.97599C22.6772 8.97599 23.127 7 25.4103 7C27.6936 7 31.1791 8.19518 31.776 11.0069C32.3729 13.8186 31.6141 15.1502 30.8361 17.514C30.058 19.8777 28.7931 21.743 28.7931 23.0589C28.7931 24.3749 28.4223 33.5157 24.9379 33.5157C21.4534 33.5157 23.3377 24.7619 19.9952 24.7619C16.6527 24.7619 18.4194 33.5157 14.8871 33.5157C11.3547 33.5157 10.9587 24.2513 10.9587 23.0589C10.9587 21.8666 10.2097 19.7071 9.17752 17.514C8.14532 15.3208 7.76276 13.5508 8.14532 11.0069C8.52787 8.46301 11.8163 7 14.4446 7C17.0728 7 17.3132 8.97599 19.9952 8.97599Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4099 7C23.1266 7 22.6768 8.976 19.9948 8.976C17.3128 8.976 17.0724 7 14.4442 7C14.4442 7 12.5693 9.9776 14.8867 11.6912C17.204 13.4048 18.8527 13.4048 19.9949 13.4048C21.1375 13.4048 22.4543 13.4048 24.9375 11.6912C27.4206 9.9776 25.4099 7 25.4099 7Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconDental40);
export default __webpack_public_path__ + "static/media/pictogramBeaconDental40.1c46b1121cfed539f6f1e7cd9cd1d44d.svg";
export { ForwardRef as ReactComponent };